import type { TimelineScale } from './useTimelineScale';

interface PlayheadCursorProps {
  time: number;
  scale: TimelineScale;
  height: number;
}

export function PlayheadCursor({ time, scale, height }: PlayheadCursorProps) {
  const x = scale.timeToX(time);

  return (
    <div
      style={{
        position: 'absolute',
        left: x,
        top: 0,
        width: 1,
        height,
        background: '#2563eb',
        pointerEvents: 'none',
        zIndex: 10,
      }}
    />
  );
}
